import React, { useCallback, useContext } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';

import LargeFileStorage from '../../../assets/large-file-storage.png';
import { DOCS_RUNNERS } from '../const';

import OnboardingContext from './OnboardingContext';
import { HeaderWrapper, StyledFileStorage } from './styled';

const Header = () => {
  const { analyticsSource } = useContext(OnboardingContext);
  const { createAnalyticsEvent } = useAnalyticsEvents();

  const viewRunnersDocumentation = useCallback(() => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'runnersDocumentationLink',
      source: analyticsSource,
    }).fire();
  }, [analyticsSource, createAnalyticsEvent]);

  return (
    <HeaderWrapper>
      <StyledFileStorage src={LargeFileStorage} alt="Large File Storage" />
      <h1>Build, test and deploy with Pipelines</h1>
      <h3>
        Easy to set up Integrated CI/CD for Bitbucket Cloud that helps you
        automate your code from test to production in the Cloud or{' '}
        <Button
          onClick={viewRunnersDocumentation}
          href={DOCS_RUNNERS}
          spacing="none"
          target="_blank"
          appearance="link"
        >
          using your own infrastructure
        </Button>
        .
      </h3>
    </HeaderWrapper>
  );
};

export default React.memo(Header);
